import {
  ActiveState,
  EntityState,
  EntityStore,
  StoreConfig,
} from '@datorama/akita';
import { TimeEntryListItem } from '../../../models/time-entry/time-entry-list-item';
import { Injectable } from '@angular/core';

export interface TimeEntriesState
  extends EntityState<TimeEntryListItem, number>,
    ActiveState {
  page: number;
  pageSize: number;
  lastPage: boolean;
  total: number;
  adminEditPermission: boolean;
}

@Injectable({
  providedIn: 'root',
})
@StoreConfig({ name: 'timeEntries', idKey: 'timeEntryID' })
export class TimeEntriesStore extends EntityStore<TimeEntriesState> {
  constructor() {
    super({
      page: 0,
      pageSize: 50,
      lastPage: false,
      total: 0,
      adminEditPermission: false,
      loading: false
    });
  }
}
